export default {
  path: '/singleQuestion',
  auth: true,
  preload: true,
  key: 'singleQuestion',
  component: () => import('./index')
};
